export default "__VITE_ASSET__B9SzQMe1__"